import ModalEventController from "./modal_event_controller"

export default class extends ModalEventController {
  connect() {
    // preserve context
    this.boundHideBackButton ||= this.hideBackButton.bind(this)
    document.addEventListener('turbo:frame-load', this.boundHideBackButton)
  }

  disconnect() {
    document.removeEventListener('turbo:frame-load', this.boundHideBackButton)
  }
}